const TEXTS = {
  ALT: {
    HAMBURGER_MENU: 'Hamburger menu icon',
  },
};

export { TEXTS };
